/**
 * The kinds of internal time a person logs, and the word the card shows
 * for each. A leaf module, so the field-error copy reads the labels
 * without importing the time-entry client, which imports that copy.
 */

export type TimeEntryKind = 'admin' | 'training' | 'meeting';

export const TIME_ENTRY_KINDS: readonly TimeEntryKind[] = ['admin', 'training', 'meeting'];

export const TIME_ENTRY_KIND_LABEL: Record<TimeEntryKind, string> = {
  admin: 'Admin',
  training: 'Training',
  meeting: 'Meeting',
};
